import { UniversalFilterConfig } from "../../components/Filters/ReportFilter";

/**
 * 📄 Proveedores
 *
 * Reporte:
 * Catálogo general de proveedores
 *
 * Filtro requerido:
 * - Estado
 *
 * Backend esperado:
 *
 * activeStatus
 */
export const supplierReportFilters: UniversalFilterConfig[] = [
    {
        name: "activeStatus",
        label: "Estado",
        type: "select",
        iconKey: "status",
    },
];